var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"VideoBg"},[_c('video',{ref:"video",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},_vm._l((_vm.sources),function(source){return _c('source',{attrs:{"src":source,"type":_vm.getMediaType(source)}})}),0),_c('div',{staticClass:"VideoBg__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }